import idCheck from './assets/img/id-check.png';
import abacus from './assets/img/abacus.png';
import hotspots from './assets/img/hotspots.png';
import lagos from './assets/img/lagos.png';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import mcLogo from './assets/img/mc-logo.svg';
import './assets/sass/App.scss';
function App() {
  return (
    <div>
      <Header />
      <div className="hero-container">
        <div className="hero">
          <img src={mcLogo} className="logo" alt="mastercard" />
        </div>
        <h1>Where Are The Hot Spots And Blind Spots For A.I. Innovation?</h1>
        <h2>Our Analysis Of 50 Global Cities</h2>
        <p>By Ajay Bhalla and Bhaskar Chakravorti </p>
      </div>
      <div className="App">
        <section className="opening">
          <div className="container">
            <p>
              Algorithms powered by A.I. and machine learning, much like other technologies that
              preceded them, carry both great promise of improving and advancing the human condition
              and enhancing productivity across a wide swath of economic activity. We have already
              seen the extraordinary impact A.I. has had on food production, agriculture, and
              healthcare; the potential is boundless—from self-driving cars to predicting financial
              markets and the weather.
            </p>
            <p>
              As we increasingly rely on A.I., it is essential to make sure that the outcomes are
              free of bias. We need to ensure that the next iteration of the global digital
              economy—powered by A.I.—is attuned to serving the breadth of human needs and does not
              discriminate. And we have found that diversity of A.I. talent—across gender, race, and
              geography—and principles of inclusive innovation are crucial ingredients for
              safeguarding that future.
            </p>
          </div>
          <img src={idCheck} alt="Mastercard ID Check" className="id-check" />
          <div className="container">
            <p>
              Our latest edition of the{' '}
              <a
                rel="noreferrer"
                target="_blank"
                href="https://sites.tufts.edu/digitalplanet/digitalintelligence/"
              >
                Digital Intelligence Index
              </a>
              , where we measure the state and rate of digital evolution across 90 economies, shows
              that while institutional and infrastructural environments are primarily determined by
              national government policy, the creation and consumption of most digital goods and
              services occurs primarily in urban clusters. Indeed, nearly
              six in ten people around the world live in cities&nbsp;
              today. In fact, talent—particularly STEM talent—is naturally drawn to such innovation
              hubs.
            </p>
            <p>
              In this analysis, we asked the following questions: Where are the emerging hot spots
              for A.I. innovation? And what, if any, are their blind spots?
            </p>
            <div className="chart">
              <img src={abacus} alt="Mastercard ID Check" />
            </div>
            <p>
              To unpack these questions, we considered four dimensions propelling A.I. innovations
              across 50 global cities with the largest A.I. talent pools: Talent (the size of the
              A.I. talent pool in the city); Investments (the levels of capital attracted by these
              cities in A.I. and emerging technologies); Diversity (the extent of diversity and
              inclusivity among A.I. talent); and Evolution of the Digital Foundations (the state of
              the country's digital advancement as{' '}
              <a
                rel="noreferrer"
                target="_blank"
                href="https://digitalintelligence.fletcher.tufts.edu/trajectory"
              >
                evidenced by our digital evolution scorecard
              </a>
              ).
            </p>
            <div className="quote">
              <p>
                "Continuous innovation, relentless focus on the consumer, and a diverse pipeline of
                talent are critical. Together they will enable an A.I.-powered future that fosters a
                more balanced and inclusive society that works for everyone, everywhere.”
              </p>
              <p className="author">Ajay Bhalla, President, Cyber & Intelligence at Mastercard</p>
            </div>
            <p>
              Our analysis shows that San Francisco, or rather the Bay Area supercluster, doesn’t
              just lead the world on talent and investments—it attracts venture capital investments
              that are greater in total than the next four city clusters New York, Boston, Seattle,
              and Bangalore combined. On A.I. talent concentration, the Bay Area is bigger than the
              combined total of New York and Seattle.
            </p>
            <p>
              When it comes to racial diversity, however, the Bay Area cluster lags the likes
              of Atlanta, Washington D.C., Los Angeles, New York, and Philadelphia in the United
              States,{' '}
              <a
                rel="noreferrer"
                target="_blank"
                href="https://sites.tufts.edu/digitalplanet/big-techs-opportunity-for-inclusive-growth/"
              >
                all of which offer a richer diversity of Black and Hispanic A.I. talent.
              </a>
              &nbsp;Cities in Canada and Australia lead the world in acceptance of migrants.
            </p>
          </div>
          <div className="chart">
            <img src={hotspots} alt="Mastercard ID Check" />
          </div>
          <div className="container">
            <p>
              Looking at gender diversity, the major U.S. hubs, such as Boston, San Francisco, and
              New York perform well relative to the others on gender diversity in A.I. talent, but
              Tel Aviv tops the list of 50. Other cities with more favorable gender diversity in
              A.I. include Edinburgh and Buenos Aires. That said, there is still a huge gender gap
              in A.I. talent across the board—and every city needs to work towards increasing the
              proportion of its female A.I. workforce.
            </p>
            <p>
              Cities on this list of A.I. hotspots that are in the “Digital South”, such as
              Hyderabad, Bangalore, Jakarta, Lagos, Nairobi, Mexico City, Buenos Aires, and São
              Paulo, score favorably on cost of living but are held back by the state of their
              digital evolution and infrastructure. Cities in Europe, such as Tallinn, Madrid,
              Barcelona, and Berlin are in the sweet spot of relatively low cost of living and a
              high state of digitalization.
            </p>

            <div className="quote">
              <p>
                "Continuous innovation, relentless focus on the consumer, and a diverse pipeline of
                talent are critical. Together they will enable an A.I.-powered future that fosters a
                more balanced and inclusive society that works for everyone, everywhere.”
              </p>
              <p className="author">
                Bhaskar Chakravorti, Dean of Global Business, The Fletcher School, Tufts University
              </p>
            </div>
            <p>
              The Bay Area today has an outsize impact on digital innovations around the world. The
              enormous concentration of A.I. resources around San Francisco and its relative lack of
              representation risks making the next iteration of the global digital economy—powered
              by A.I. and related emerging technologies—less inclusive. Besides, it is becoming
              increasingly clear that one of the greatest constraints on the growth of the A.I.
              economy is the availability of A.I. talent. It is essential to tap multiple talent
              pools beyond the super-clusters at the very top.
            </p>
          </div>
          <img src={lagos} alt="Digital Assets" className="id-check" />
          <div className="container">
            <p>
              Overall, technologists, innovators, investors, and business leaders would do well to
              look across the wider set of A.I. hotspots and seek out cities that provide large
              pools and diversity of talent, investments, and solid digital foundations. And local
              governments and policymakers are advised to pay particular attention to their city's
              own potential as a hub in the emerging A.I. economy. They would benefit from promoting
              their cities—to investors and employers—as the industry takes steps towards building a
              wider footprint in pursuit of talent and diversity of input.
            </p>
            <p className="italics-text">
              The authors are grateful to Paul Trueman of Mastercard and Ravi Shankar Chaturvedi,
              Christina Filipovic, Joy Zhang, and the Digital Planet team at Tufts University’s
              Fletcher School.
            </p>
            <p className="bold-text">
              For detailed recommendations on how economies can improve their overall digital
              competitiveness, visit our interactive{' '}
              <a
                rel="noreferrer"
                target="_blank"
                href="https://sites.tufts.edu/digitalplanet/digitalintelligence/"
              >
                Digital Intelligence Index
              </a>
              .
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default App;
